// extracted by mini-css-extract-plugin
export default {"container":"xL-z","error":"yL-z","disabled":"zL-z","submit":"AL-z","option":"BL-z","success":"CL-z","failure":"DL-z"};